import { ReactElement, useEffect, useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { ContentLabelField } from '@hopskipdrive/react-components';
import * as Yup from 'yup';

import ChipSelect from '../../../components/ChipSelect';
import { useGetOffenderTypes } from '../../../hooks/useIncidentApi';
import { IncidentOffenderType } from '../../../types/incidents';

interface OffenderTypeFieldProps {
  defaultValue?: string;
  setOffenderTypes?: (offenderTypes: IncidentOffenderType[]) => void;
}

export const offenderTypeValidation = Yup.string().required('Alleged offender type is required').nullable();

export const OffenderTypeField = ({ defaultValue }: OffenderTypeFieldProps): ReactElement => {
  const { data: response } = useGetOffenderTypes();
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name: 'offenderType',
    control,
    defaultValue: defaultValue || null,
  });
  const [offenderTypes, setOffenderTypes] = useState<IncidentOffenderType[]>([]);

  useEffect(() => {
    setOffenderTypes(response?.data || []);
  }, [response]);

  return (
    <ContentLabelField
      id="offenderType"
      title="Alleged Offender"
      editMode={true}
      required={true}
      editView={
        <ChipSelect
          options={offenderTypes}
          value={field.value}
          onChange={field.onChange}
          placeholder="Select"
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
        />
      }
    />
  );
};
